"use strict";
angular.module('planTimeCueDetailModule', [
        'DetailRouterModule',
        'planningcenterWenZhangDetailModule',
        'planningcenterWeiBoDetailModule'
    ])
    .controller('planTimeCueDetailController', ["$scope", function($scope) {

    }]);
